"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const node_fetch_1 = require("node-fetch");
const shared_1 = require("../shared");
const get = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = yield (0, shared_1.getRequestHeaders)(request);
    const options = {
        headers,
        method: 'GET',
        redirect: 'follow',
    };
    const url = (0, shared_1.getEndpointUrl)(request);
    const response = yield (0, node_fetch_1.default)(url, options);
    if (response.ok) {
        return response.status === 204 ? {} : response.json();
    }
    return Promise.reject(response);
});
exports.default = get;
